import it from "./it";
import en from "./en";


//Retrieving browser language
let userLang = navigator.language;

//Setting localStorage's default value for the website's language
if (!localStorage.getItem("lang")) {
    if (userLang.startsWith('it'))
        localStorage.setItem('lang', 'it');
    else
        localStorage.setItem('lang', 'en');
}

const locale = {
    it,
    en,
};

export const localeMapper = {
    it: "it-IT",
    en: "en-EN"
}

export default locale;
